export default __webpack_public_path__ + "static/media/bg.d7b55be0.svg";